import { useEffect, useRef } from 'react';
import { useAudioStore } from './useAudioStore';
import { getAzuraCastStationShortcode } from '@/utils/streamSource';
import { fetchNowPlaying } from '@/services/azuracast';
import type { TrackInfo } from '@/types';

const POLL_INTERVAL_MS = 10000; // 10 sekundi

/** Polling za AzuraCast Now Playing – artist, title za trenutnu pesmu */
export function useAzuraCastMetadata() {
  const { currentStation, setCurrentTrack } = useAudioStore();
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (!currentStation?.streamUrl) return;

    const shortcode = getAzuraCastStationShortcode(currentStation.streamUrl);
    if (!shortcode) return;

    const poll = async () => {
      const np = await fetchNowPlaying(shortcode);
      if (np) {
        const track: TrackInfo = {
          title: np.title || 'Nepoznata pjesma',
          artist: np.artist || 'Nepoznati izvođač',
          artwork: np.art,
        };
        setCurrentTrack(track);
      }
    };

    poll();
    intervalRef.current = setInterval(poll, POLL_INTERVAL_MS);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [currentStation?.id, currentStation?.streamUrl, setCurrentTrack]);
}
